import { TDR } from 'tdr-common';

export const DEFAULT_PARAMETER_GUEST_MAX = 100;

export function getParameterGuestMax(restaurant: TDR.Restaurant | undefined): number {
	const override = restaurant?.settings?.parameterGuestSizeMax;
	return typeof override === 'number' && override >= 1 ? override : DEFAULT_PARAMETER_GUEST_MAX;
}
